module.exports = __webpack_public_path__ + "img/powder-turbo.ed4a5599.webp";